import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1beda564"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "app",
  style: {"margin-top":"20px"}
}

import {useRouter} from 'vue-router'
    import {defineComponent,ref} from "vue";
    import ScanView from "@/views/ScanView.vue";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

    const router=useRouter();
    const showScanView = ref(false);
    const isFullScreen = ref(false);
    const username=ref('')
    const workshopitem=ref('')

    username.value=localStorage.getItem('zhiyuan_username')
    workshopitem.value   =  localStorage.getItem('zhiyuan_workshop')
    function logout() {
        localStorage.removeItem('token')
        localStorage.removeItem('zhiyuan_username')
        router.push('/bindingperson')
    }

    function refreshComponent() {
       location.reload()
    }

    // function pu() {
    //     router.push('/getprojectinfocd?printno=P2306-0006&pjcheckid=0A5E65D7-A58D-44E2-A05B-FBBF515A29F3&cardid=P2306-0006-1')
    // }

    const mycomponent=  defineComponent({
      components: {
             ScanView,
        }})

    function toggleFullScreen() {
      isFullScreen.value = !isFullScreen.value;
      showScanView.value = true;
    }
    function stopScanning() {
      showScanView.value = false;
      isFullScreen.value = false;
    }

    function wp_query(){
         router.push('/getwp_no')
    }



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: logout,
                      span: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重新绑定")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: toggleFullScreen
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("扫描下一条")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: refreshComponent,
                      span: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("刷新")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", null, "当前用户:" + _toDisplayString(username.value) + ",所属车间:" + _toDisplayString(workshopitem.value), 1)
                    ]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: wp_query
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("件资记录")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["scan-wrapper", { 'fullscreen': isFullScreen.value }])
    }, [
      (showScanView.value)
        ? (_openBlock(), _createBlock(ScanView, {
            key: 0,
            onScanComplete: stopScanning
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})